import { render, staticRenderFns } from "./CABPCNotification.vue?vue&type=template&id=1a709c56"
import script from "./CABPCNotification.vue?vue&type=script&lang=js"
export * from "./CABPCNotification.vue?vue&type=script&lang=js"
import style0 from "./CABPCNotification.vue?vue&type=style&index=0&id=1a709c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports